import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import WhatsappContactLink from '../link/whatsapp-contact-link';

export default function WhatsAppFloatingButton() {
	return (
		<WhatsappContactLink
			className={'fixed bottom-20 right-8 sm:right-16 sm:bottom-12 btn btn-circle btn-success size-16 drop-shadow-xl shadow-lg'}>
			<FontAwesomeIcon size={'3x'} icon={faWhatsapp} color={'white'}/>
		</WhatsappContactLink>
	);
}